/**
 * Sorts an array of products by their active status and then by order.
 * Active products come first. Within the same active status,
 * products with defined 'order' values are sorted in ascending order.
 * If 'order' is not defined, the original relative position is maintained.
 *
 * @param products - Array of products with isActive and optional order fields.
 * @returns A new sorted array based on active status and order.
 */
export default function sortProductsByActiveThenOrder<T extends { isActive: boolean; order?: number | null }>(products: T[]): T[] {
  return [...products].sort((productA, productB) => {
    if (productA.isActive !== productB.isActive) return productA.isActive ? -1 : 1;

    if (productA.order != null && productB.order != null) return productA.order - productB.order;
    if (productA.order != null) return -1;
    if (productB.order != null) return 1;

    return 0;
  });
}
